export const PAYMENT_STATUSES = {
  PENDING: 'pending',
  MEMBER_SUBMITTED: 'member_submitted',
  PAID: 'paid',
  REJECTED: 'rejected',
  LATE: 'late',
  COVERED: 'covered',
};

export const PAYMENT_STATUS_LABELS = {
  pending: 'Pending',
  member_submitted: 'Submitted',
  paid: 'Paid',
  rejected: 'Rejected',
  late: 'Late',
  covered: 'Covered',
};

export const PAYMENT_STATUS_CLASSES = {
  pending: 'bg-warning-100 text-warning-800',
  member_submitted: 'bg-accent-100 text-accent-800',
  paid: 'bg-success-100 text-success-800',
  rejected: 'bg-error-100 text-error-800',
  late: 'bg-error-100 text-error-800',
  covered: 'bg-warning-100 text-warning-800',
};
